export default {
  feedback: {
    success: 'Mobilappen blev gemt',
    error: 'Mobilappen kunne ikke gemmes',
  },
};
